module.exports = __webpack_public_path__ + "static/media/TileSSO.82970289.png";